import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import HomePage from "./pages/home-page";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import { ReactComponent as Logo } from "./assets/icons/Logo.svg";
import Services from "./pages/services";
import AboutUs from "./pages/about-us";
import ContactUs from "./pages/contact-us";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";

function AppContent() {
  const location = useLocation();
  return (
    <>
      <div className="sticky-header" >
        {location.pathname === "/" &&
          <div style={{ maxWidth: '1440px', margin: '0 auto', width: '100%', position: 'relative' }}>
            <div className={`logo-div`} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ cursor: 'pointer' }}>
              <Logo />
            </div>
          </div>
        }
        <Navbar />
      </div>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
      <Footer />
    </>
  );
}



function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
